import type { Content } from '@/services/isomorphic/ContentService';
import { Suspense, use, type FC } from 'react';
import { RenderContent } from '../../content/core/Content/RenderContent';
import { CommonErrorBoundary } from '../../errors/boundaries/CommonErrorBoundary';
import SkeletonLoader from '../../utility/SkeletonLoader';

import S from './styles.base.module.scss';

interface IMessagesProps {
  /** The promotional messages. */
  messages: Promise<Array<Content>>;
}
/** Display the messages if any. */
const Messages: FC<IMessagesProps> = ({ messages }) => {
  const resolvedMessages = use(messages);

  if (resolvedMessages.length === 0) return null;
  return (
    <div className={S.promotionalMessages}>
      {resolvedMessages.map((content) => (
        <div className={S.promotionalMessage} key={content.data?.id}>
          <RenderContent content={content} />
        </div>
      ))}
    </div>
  );
};

/**
 * Display the promotional messages using suspense and fallback to
 * empty if there's an error.
 */
const PromotionalMessages: FC<IMessagesProps> = ({ messages }) => (
  <CommonErrorBoundary>
    <Suspense fallback={<SkeletonLoader />}>
      <Messages messages={messages} />
    </Suspense>
  </CommonErrorBoundary>
);

export default PromotionalMessages;
